import { Component } from 'vue-property-decorator';
import { Page } from '../../helpers/components';
import { BasePage } from '../base-page';
import { WmsLayout } from '../../components/layout/layout';

@Page(WmsLayout) @Component
export class EmptyPageWithLayout extends BasePage {
}

export default EmptyPageWithLayout;
